import type { RouteRecordRaw } from 'vue-router'
import type { Empty } from './types'

export interface RouteParams {
    'data-request-recipient-homepage': Empty
    'data-request-fill-out': { id: string }
    'data-request-review': { id: string }
    'data-request-view': { id: string }
}

const routes: RouteRecordRaw[] = [
    {
        name: 'data-request-recipient-homepage',
        path: '',
        component: () => import('@/vue/data-request/components/Homepage.vue'),
    },
    {
        name: 'data-request-fill-out',
        path: '/:id/fill-out',
        component: () => import('@/vue/data-request/components/Fillout.vue'),
    },
    {
        name: 'data-request-review',
        path: '/:id/review',
        component: () => import('@/vue/data-request/components/Fillout.vue'),
        props: { review: true },
    },
    {
        name: 'data-request-view',
        path: '/:id/view',
        component: () => import('@/vue/data-request/components/Fillout.vue'),
        props: { view: true },
    },
]

export default routes
